import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, ClipboardList, Users, Inbox, LogOut } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/requests", label: "Requests", icon: ClipboardList },
  { to: "/admin/inbox", label: "Inbox", icon: Inbox },
  { to: "/admin/suppliers", label: "Suppliers", icon: Users },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/"); };

  return (
    <div className="min-h-screen flex bg-background">
      <aside className="w-64 shrink-0 bg-ink text-white flex flex-col fixed h-screen">
        <div className="p-6 border-b border-white/10">
          <Logo light />
          <div className="mt-3 inline-block text-[10px] font-bold uppercase tracking-widest bg-coral px-2 py-0.5 rounded-sm">Admin</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-sm text-sm font-semibold transition-colors ${
                  isActive ? "bg-coral text-white" : "text-white/60 hover:bg-white/10 hover:text-white"
                }`
              }
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
            >
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="px-2 mb-3">
            <div className="text-sm font-semibold truncate">{user?.name}</div>
            <div className="text-xs text-white/50 truncate">{user?.email}</div>
          </div>
          <button onClick={doLogout} className="flex items-center gap-3 px-4 py-2.5 rounded-sm text-sm font-semibold text-white/60 hover:bg-white/10 hover:text-white w-full transition" data-testid="admin-logout">
            <LogOut size={18} /> Sign out
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-6 md:p-10">
        <Outlet />
      </main>
    </div>
  );
}
